import WacUrlInfo from 'owa-attachment-wac/lib/types/WacUrlInfo';
import { ClientItemId } from 'owa-client-ids';
import { action } from 'satcheljs';

export const tryProcessSharePointLink = action(
    'tryProcessSharePointLink',
    (element: HTMLElement, itemId: ClientItemId) => ({
        element,
        itemId,
    })
);

export const tryUndoProcessSharePointLink = action(
    'tryUndoProcessSharePointLink',
    (elements: HTMLElement[]) => ({
        elements,
    })
);

export const previewLinkInSxS = action(
    'previewLinkInSxS',
    (wacUrlGetter: () => Promise<WacUrlInfo>, itemId: ClientItemId) => ({
        wacUrlGetter,
        itemId,
    })
);
